// api/register.ts
import { Method } from 'axios';
import { generateHash } from '@/utility/auth/generateHashValue';
import { apiCall } from '@/utility/api/apiUtils';
import { RegisterFormType } from '@/helpers/types';
import { API_METHOD_POST, API_REGISTER_URL } from '@/constants/apiConstants';

export const registerUser = async (values: RegisterFormType) => {
  const method: Method = API_METHOD_POST;
  const url = API_REGISTER_URL;
  const data = {
    first_name: values.firstName,
    last_name: values.lastName,
    email: values.email,
    phone: values.phoneNumber,
    dial_code: values.dial_code,
    iso_code: values.iso_code,
    invitation_token: values.supplier_referral,
    password: values.password,
    company_name: '',
    agree: true,
    r_id: values.r_id,
  };

  // Convert JSON object to string
  const jsonString = JSON.stringify(data);
  const additionalHeaders = {
    hash: generateHash(jsonString),
  };

  try {
    return await apiCall({
      method,
      url,
      data,
      headers: additionalHeaders,
    }); // Return the response data for further use
  } catch (error) {
    throw error;
  }
};
